import { cn } from '@packages/ui/styling/cn';
import type { ComponentProps } from 'react';

type DisplayParticipantNameProps = ComponentProps<'span'> & {
  name: string;
};

/**
 * Component to safely display user-generated names that might be extremely long
 * or lack spaces (e.g. "SuperLongNameWithoutSpaces").
 *
 * Technical decisions:
 * 1. Uses `wrap-anywhere` to force breaks mid-word only when necessary to prevent
 *    overflow, while preserving normal word breaks for readability.
 * 2. Does NOT include `truncate` by default. Names should usually wrap fully
 *    (headings, warnings). If truncation is needed (buttons), the parent
 *    should apply `truncate` and `min-w-0` to the container.
 */
export const DisplayParticipantName = ({
  name,
  className,
  ...props
}: DisplayParticipantNameProps) => {
  return (
    <span className={cn('wrap-anywhere', className)} {...props}>
      {name}
    </span>
  );
};
